import { render, staticRenderFns } from "./CurrencyDropdown.vue?vue&type=template&id=175daeb3&"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=js&"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports